import {
 call, put, select, takeLatest,
} from 'redux-saga/effects';
import { languageSelector } from '../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../locales/locales';
import { POOL_MEMBERSHIP_MANAGEMENT_SAVE_REQUEST } from '../actions/types/PoolMembershipManagementActionTypes';
import apiPutPoolMembershipManagementSelections from '../../api/PoolMembershipManagementAPI';
import {
  poolMembershipManagementSaveFailureActionCreator,
  poolMembershipManagementSaveSuccessActionCreator,
} from '../actions/PoolMembershipManagementActions';

function* doSavePoolMembershipManagementWorker(action) {
  const lang = yield select(languageSelector);

  try {
    const response = yield call(apiPutPoolMembershipManagementSelections, action.payload);
    yield put(poolMembershipManagementSaveSuccessActionCreator(response.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.pool.management.update.success'),
    }));
  } catch (error) {
    let message = formatMessage(lang, 'app.server.error');
    if (error.response.data.BusinessError !== undefined) {
      message = formatMessage(lang, error.response.data.BusinessError.messageKey);
    }
    yield put(poolMembershipManagementSaveFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message,
    }));
  }
}

function* doSavePoolMembershipManagementWatcher() {
  yield takeLatest(POOL_MEMBERSHIP_MANAGEMENT_SAVE_REQUEST, doSavePoolMembershipManagementWorker);
}

export default doSavePoolMembershipManagementWatcher;
